import { FC, HTMLAttributes } from "react";
import clsx from "clsx";

import CurrentOpeningCard, {
  IOpeningCard,
} from "@/components/cards/CurrentOpeningCard";
import SectionHeader from "../common/SectionHeader";
import RevealOnScroll from "@/components/common/RevealOnScroll";

// ------------------------------------------------------------------------------

export type ICurrentOpeningSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  cards?: IOpeningCard[];
};

const CurrentOpeningSection: FC<ICurrentOpeningSectionProps> = (props) => {
  const { heading, cards, className, ...other } = props;

  return (
    <section className={clsx("py-14 md:py-20 xl:py-24", className)} {...other}>
      <div className="bg-primary-50 py-10 lg:py-16 xl:py-20">
        <div className="container">
          {heading && (
            <RevealOnScroll>
              <SectionHeader
                title={heading}
                align="left"
                className="mb-8 md:mb-12"
              />
            </RevealOnScroll>
          )}

          {cards && cards.length > 0 && (
            <div className="grid gap-5 md:grid-cols-2 md:gap-x-8 md:gap-y-[30px] xl:grid-cols-3">
              {cards.map((card, idx) => (
                <RevealOnScroll key={idx} index={idx} className="h-full">
                  <CurrentOpeningCard
                    heading={card.heading}
                    button={card.button}
                    list={card.list}
                    isHiring={card.isHiring}
                  />
                </RevealOnScroll>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CurrentOpeningSection;
